import useTranslation from 'next-translate/useTranslation';
import { IconsNames } from '@eqi-investimentos/icons/web';
import { Flex, Link, Text } from '@eqi-investimentos/react';
import { appConfig } from '@/config/app';
import { Icon } from '@/components/atoms/Icon';
import { Thumb } from '@/components/atoms/Thumb';
import { Drawer } from '@/components/molecules/Drawer';
export const SupportDrawer = () => {
  const {
    t
  } = useTranslation('common');
  return <Drawer id={SUPPORT_DRAWER_ID} headerContent={<Text>{t('drawers.support.header')}</Text>} data-sentry-element="Drawer" data-sentry-component="SupportDrawer" data-sentry-source-file="index.tsx">
      <Flex flexDir="column" gap="1.875rem" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Text fontSize="lg" fontWeight="semibold" lineHeight="7" color="var(--color-eqi-black)" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {t('drawers.support.title')}
        </Text>
        <Text fontWeight="light" lineHeight="5" color="var(--color-eqi-black)" data-sentry-element="Text" data-sentry-source-file="index.tsx">
          {t('drawers.support.description')}
        </Text>
        <Flex flexDir="column" gap="2.5" py="1.875rem" px="5" mt="2.5" bgColor="var(--color-eqi-white)" borderRadius="lg" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Flex alignItems="center" gap="5" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            <Thumb src="/assets/eqi_placeholder_v2.png" width={58} height={58} radius={58} data-sentry-element="Thumb" data-sentry-source-file="index.tsx" />
            <Text fontSize="lg" fontWeight="semibold" color="var(--color-eqi-black)" data-sentry-element="Text" data-sentry-source-file="index.tsx">
              {t('drawers.support.cardTitle')}
            </Text>
          </Flex>
          <Flex flexDir="column" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
            {contacts.map(({
            content,
            icon,
            link
          }) => {
            const hasLink = !!link?.length;
            return <Link key={`support-item-${content}`} href={link} target="_blank" rel="noopener noreferrer" display="flex" justifyContent="space-between" py="5" w="full" borderBottom="1px solid var(--color-eqi-gray-lighten-3)" {...!hasLink && {
              as: 'div',
              cursor: 'default',
              _hover: {
                textDecoration: 'none'
              }
            }}>
                  <Flex alignItems="center" gap="2.5">
                    <Icon iconName={icon} w="6" h="6" color="var(--color-orange-primary)" />
                    <Text>{content}</Text>
                  </Flex>
                  {hasLink && <Icon iconName="ChevronRight" w="6" h="6" />}
                </Link>;
          })}
          </Flex>
        </Flex>
      </Flex>
    </Drawer>;
};
export const SUPPORT_DRAWER_ID = 'support-drawer';
const contacts: {
  icon: IconsNames;
  content: string;
  link?: string;
}[] = [{
  icon: 'PhoneFilled',
  content: '4007-2374'
}, {
  icon: 'Whatsapp',
  content: '+55 (47) 4007-2374',
  link: `${appConfig.support.whatsAppUrlBase}?phone=${appConfig.support.number}&text=${appConfig.support.message}`
}, {
  icon: 'MailOutline',
  content: 'atendimento@eqi.com.br'
}];